import { Order } from 'graphql-api/baskets-api-interfaces';

export function getUniqueOrderId(order: Order) {
  return `${order.rootId}-${order.salesOrderNumber}`;
}
